import manTechnologist from "../assets/img/manTechnologist.png";
import wavingHand from ".././assets/img/wavingHand.png";
import ScrollReveal from "./Hooks/ScrollReveal";

const Contact = ({ contactData, socialsData ,aboutData}) => {
    return (
        <section id="contact" className="flex flex-col  ">
            <div className="flex flex-col sm:flex-row sm:justify-center items-center bg-gray-100 sm:py-0 py-32">
                
                <div className="mx-10 sm:mb-0 mb-4 sm:block ">
                    <ScrollReveal>
                    <img src={manTechnologist} className="sm:h-32 h-16 " alt="" />
                    </ScrollReveal>
                </div>

                <div className="flex flex-col justify-center  sm:py-32 sm:w-1/3">
                    <ScrollReveal>
                        <h1 className="mb-2 uppercase text-center sm:text-left  text-2xl font-openSans font-semibold">{contactData.title}</h1>
                    </ScrollReveal>
                    <ScrollReveal>
                        <p className="text-black mx-8    sm:m-auto uppercase sm:text-left text-center  text-xs font-openSans font-medium mt-1 sm:mt-2">{contactData.description}
                        {/* <img src={wavingHand} className="h-4 inline px-1 " alt="" /> */}
                        </p>
                        </ScrollReveal>
                        
                        <span className="mt-4 mx-auto sm:mx-0 gap-1">
                        <ScrollReveal>
                            <div className="flex sm:flex-row flex-col">
                                
                        <a className="uppercase text-center text-xs font-openSans font-semibold mt-4 hover:text-black hover:bg-transparent border-2 border-black px-4 py-0.5 m-auto sm:ml-0 sm:mr-2 w-max 
                    text-white bg-black 
                    "
                    href={`mailto:${socialsData.mail}`}
                    >
                        {contactData.buttonTitle}
                        </a>

                        <a href={aboutData.resumeLink} className="cursor-pointer hover:border-2 box-border hover:border-sky-500 uppercase text-center text-xs font-openSans font-semibold mt-4 text-sky-600   px-4 py-0.5 m-auto sm:mx-0 w-max 
                     ">
                        my Resume
                        </a>
                        </div>
                    </ScrollReveal>
                        </span>
                </div>


            </div>
            <div className="bg-black px-8 sm:px-12 text-gray-100 flex flex-col  pt-20">

                <a className="w-max"
                    href={`mailto:${socialsData.mail}`}
                >
                    <h1 className="lowercase text-2xl  sm:text-6xl font-openSans font-semibold">{socialsData.mail}</h1>
                </a>

                <div className="mt-4 sm:mt-10 font-6rem  decoration-1 uppercase sm:text-md  font-openSans font-semibold">
                    <div className="inline">
                        <a href={socialsData.github} target={socialsData.github == "#0" ? `_self` : '_blank'} className=" hover:line-through mr-4 ">Github</a>
                    </div>
                    <div className="inline">
                        <a href={socialsData.linkedin} target={socialsData.linkedin == "#0" ? `_self` : '_blank'} className=" hover:line-through mr-4">Linkedin</a>
                    </div>
                    <div className="inline">
                        <a href={socialsData.instagram} target={socialsData.instagram == "#0" ? `_self` : '_blank'} className=" hover:line-through mr-4">Instagram</a>
                    </div>
                    <div className="inline">
                        <a href={socialsData.twitter} target={socialsData.twitter == "#0" ? `_self` : '_blank'} className=" hover:line-through mr-4">Twitter</a>
                    </div>
                </div>

                <div className="flex flex-row justify-between uppercase pt-20 pb-10 text-left  h-full font-openSans font-medium text-gray-400 font-6rem">
                    <span>
                        Design &amp; built by KSN
                    </span>
                    <span >
                        2022
                    </span>
                </div>
            </div>
        </section>
    );
};

export default Contact;